import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';
import useApiMutation from '../useApiMutation';
import keys from './keys';
import customerKeys from '../customer/keys';
import userKeys from '../user/keys';
import featuresKeys from '../features/keys';
import useMessage from '../../useMessage';

const useCreateShow = () => {
  const { message } = useMessage();
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: () => '/shows',
    method: 'POST',
    onSuccess: (newShowData) => {
      queryClient.setQueryData(keys(newShowData._id).show, newShowData);
      queryClient.invalidateQueries(keys().shows);
      queryClient.invalidateQueries(customerKeys.customer);
      queryClient.invalidateQueries(userKeys.me);
      queryClient.invalidateQueries(
        featuresKeys.list({
          networkId: newShowData.network,
          showId: newShowData._id,
        })
      );
    },
    onError: () => {
      message.danger({
        content: <FormattedMessage defaultMessage="There was an error while creating your show." />,
      });
    },
  });

  return {
    createShow: mutation.mutate,
    isCreateShowLoading: mutation.isLoading,
    isCreateShowError: mutation.isError,
    isCreateShowSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useCreateShow;
